import { LegacyRefererHandler } from './Component';

export default {
  type: 'referer',
  setup: async ({ app }) => {
    app.extension.registerComponent('root', {
      Component: LegacyRefererHandler,
    });
  },
};
